import _extends from "@babel/runtime/helpers/extends";
import MuiMenuItem from "@mui/material/MenuItem";
import classNames from "classnames";
import React from "react";
import ListItemIcon from "../ListItemIcon";
import useStyles from "./styles";
import ListItemText from "../ListItemText";
export const menuItemAsObj = menuItem => menuItem;
export const MenuItem = /*#__PURE__*/React.forwardRef((props, ref) => {
  const {
    children,
    icon,
    className,
    action,
    ListItemIconProps,
    iconLocation = "left",
    ...otherProps
  } = props;
  const classes = useStyles(props);
  const iconSection = /*#__PURE__*/React.createElement(ListItemIcon, _extends({
    className: classNames(classes.icon, {
      [classes.alignEnd]: iconLocation === "right"
    })
  }, ListItemIconProps), icon);
  return /*#__PURE__*/React.createElement(MuiMenuItem, _extends({}, otherProps, {
    ref: ref,
    className: classNames("prmbl-menuItem", className)
  }), iconLocation === "left" && icon && iconSection, /*#__PURE__*/React.createElement(ListItemText, null, children), iconLocation === "right" && icon && iconSection);
});
MenuItem.displayName = "MenuItem";
MenuItem.defaultProps = {
  iconLocation: "left"
};
export default MenuItem;